// Cara Ldn free gift sync (added by Claude, reversible).
// Keeps the free gift in the cart only while there are enough paid items:
//   paid items >= minItems  -> gift quantity 1 (unless the shopper deliberately removed it)
//   paid items <  minItems  -> gift removed
// The gift is only free at checkout because of the Shopify "Free gift" automatic discount.
import { morphSection } from '@theme/section-renderer';
import { ThemeEvents } from '@theme/events';

const config = window.caraGift || {};
const GIFT = Number(config.variantId);
const MIN = Number(config.minItems) || 2;
const DECLINED = 'cara-gift-declined';

if (GIFT && !window.__caraGiftSync) {
  window.__caraGiftSync = true;

  const routes = window.Theme?.routes || {};
  let busy = false;
  let pending = false;
  let timer;
  let lastGiftQty = null;
  let removedByUs = false;

  const storage = {
    get: () => {
      try { return sessionStorage.getItem(DECLINED) === '1'; } catch (_) { return false; }
    },
    set: (on) => {
      try { on ? sessionStorage.setItem(DECLINED, '1') : sessionStorage.removeItem(DECLINED); } catch (_) {}
    },
  };

  const sectionIds = () =>
    [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);

  async function sync() {
    if (busy) {
      pending = true;
      return;
    }
    busy = true;
    try {
      const cart = await fetch(`${routes.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((r) =>
        r.json()
      );

      let paid = 0;
      let gift = 0;
      for (const item of cart.items || []) {
        if (item.variant_id === GIFT) gift += item.quantity;
        else paid += item.quantity;
      }

      // Shopper removed the gift themselves while still qualifying: respect that until they drop below the minimum.
      if (lastGiftQty > 0 && gift === 0 && paid >= MIN && !removedByUs) storage.set(true);
      if (paid < MIN) storage.set(false);
      removedByUs = false;

      let target = gift;
      if (paid >= MIN) {
        if (gift === 0 && !storage.get()) target = 1;
        else if (gift > 1) target = 1;
      } else if (gift > 0) {
        target = 0;
      }

      if (target !== gift) {
        const body = { updates: { [GIFT]: target } };
        const ids = sectionIds();
        if (ids.length) {
          body.sections = ids.join(',');
          body.sections_url = window.location.pathname;
        }
        const updated = await fetch(`${routes.cart_update_url || '/cart/update'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        }).then((r) => r.json());

        if (target < gift) removedByUs = true;
        gift = target;

        // Refresh the cart drawer / cart page and the cart count without firing cart:update,
        // which would pop the cart drawer open.
        for (const [id, html] of Object.entries(updated.sections || {})) {
          if (html) morphSection(id, html);
        }
        const icon = document.querySelector('cart-icon');
        if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(updated.item_count, false, false);
      }

      lastGiftQty = gift;
    } catch (error) {
      console.warn('[cara-gift]', error);
    } finally {
      busy = false;
      if (pending) {
        pending = false;
        schedule();
      }
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  document.addEventListener(ThemeEvents.cartUpdate, schedule);
  schedule();
}
